

















































































import {Vue, Component, Watch, Prop} from "vue-property-decorator";

@Component
export default class SearchBox extends Vue {

  isDataLoaded = false;

  search_model = [];
  search_input = null;

  search_items = [
    { header: 'Select an option or create one' },
    {
      text: 'Foo',
      color: 'blue',
    },
    {
      text: 'Bar',
      color: 'red',
    },
  ];

  search_nonce = 1;
  search_menu = false;

  colors = ['green', 'purple', 'indigo', 'cyan', 'teal', 'orange'];
  editing = null;
  index = -1;

  @Watch('model')
  onSeachChanged(val: any, prev: any) {

    if (val.length === prev.length) return;

    this.search_model = val.map(v => {
      if (typeof v === 'string') {
        v = {
          text: v,
          color: this.colors[this.search_nonce - 1],
        };

        this.search_items.push(v);
        this.search_nonce++;
      }

      return v;
    });

  }

  test(){
    console.log("testt");
  }

  search_filter (item, queryText, itemText) {
    if (item.header){
      return false;
    }

    const hasValue = val => val != null ? val : '';

    const text = hasValue(itemText);
    const query = hasValue(queryText);

    return text.toString()
      .toLowerCase()
      .indexOf(query.toString().toLowerCase()) > -1
  }

  search_edit_item (index, item) {
    if (!this.editing) {
      this.editing = item
      this.index = index
    } else {
      this.editing = null
      this.index = -1
    }
  }

}
